import { Button } from "@/components/ui/button";

interface TourPopupProps {
  message: string;
  helperText?: string;
  showGotIt?: boolean;
  showBackLink?: boolean;
  onGotIt?: () => void;
  onExit: () => void;
  onBack?: () => void;
}

export default function TourPopup({
  message,
  helperText,
  showGotIt = false,
  showBackLink = false,
  onGotIt,
  onExit,
  onBack,
}: TourPopupProps) {
  return (
    <div
      role="dialog"
      aria-live="polite"
      className="bg-white rounded-2xl shadow-2xl border border-gray-200 p-5"
    >
      <p className="text-sm text-gray-800 leading-relaxed">{message}</p>

      {helperText && (
        <p className="text-xs text-gray-500 mt-2">{helperText}</p>
      )}

      <div className="mt-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          {showGotIt && (
            <Button
              size="sm"
              onClick={onGotIt}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              Got it
            </Button>
          )}
        </div>
        <button
          type="button"
          onClick={onExit}
          className="text-sm text-gray-600 hover:text-gray-900 font-medium"
        >
          Exit guide
        </button>
      </div>

      {showBackLink && (
        <div className="mt-2">
          <button
            type="button"
            onClick={onBack}
            className="text-sm text-blue-600 hover:text-blue-700 font-medium underline underline-offset-2"
          >
            Back to Getting Started
          </button>
        </div>
      )}
    </div>
  );
}
